'use strict';

var COLOR_REFERENCE = {
  TYPE: {
    MANUAL: 'Manual',
    CALCULATED: 'Calculated',
  },
  TAG: {
    RECOMMENDED: 'Recommended',
    UPLOADED: 'Uploaded',
    UPLOADING: 'Uploading',
    REPLACED: 'Replaced',
  },
};

module.exports = COLOR_REFERENCE;
